import { useMemo } from 'react';

import { ExamPendency } from '@/data/hook/student-dashboard/useStudentExamPendency';

export enum PendencyType {
  SCHEDULED_EXAM = 'SCHEDULED_EXAM',
  HOMEWORK = 'HOMEWORK',
  NEXT_LESSON = 'NEXT_LESSON',
}

export type Pendency = {
  type: PendencyType;
  count: number;
  date?: string;
};

type UseVisiblePendenciesParams = {
  exam: ExamPendency;
  homeworkCount: number;
  nextLessonDate?: string;
  limit: number;
};

export default function useVisiblePendencies({
  exam,
  homeworkCount,
  nextLessonDate,
  limit,
}: UseVisiblePendenciesParams) {
  return useMemo<Pendency[]>(() => {
    const byPriority: Pendency[] = [
      {
        type: PendencyType.SCHEDULED_EXAM,
        count: exam.count,
        date: exam.dueDate,
      },
      { type: PendencyType.HOMEWORK, count: homeworkCount },
      {
        type: PendencyType.NEXT_LESSON,
        count: nextLessonDate ? 1 : 0,
        date: nextLessonDate,
      },
    ];

    return byPriority.filter(({ count }) => count > 0).slice(0, limit);
  }, [exam, homeworkCount, nextLessonDate, limit]);
}
